import React, {useState} from "react";
import {Button, Grid2} from "@mui/material";
import Typography from "@mui/material/Typography";
import {UserProfileAddressDTO, UserProfileDTO} from "../ProfilePersonalDetails";
import IconButton from "@mui/material/IconButton";
import {DeleteOutline, EditOutlined} from "@mui/icons-material";
import ProfileAddressesAddModal from "./profileAdressesAddModal/ProfileAddressesAddModal";
import ProfileAddressesDeleteModal from "./profileAddressesDeleteModal/ProfileAddressesDeleteModal";
import ProfileAddressesEditModal from "./profileAdressesEditModal/ProfileAdressesEditModal";

interface ProfileAdressesDetailsProps {
    profile: UserProfileDTO,
}

const ProfileAddressesDetails = ({profile}: ProfileAdressesDetailsProps) => {

    const [openAddAddress, setOpenAddAddress] = useState<boolean>(false);
    const [openDeleteAddress, setOpenDeleteAddress] = useState<boolean>(false);
    const [selectedAddress, setSelectedAddress] = useState<UserProfileAddressDTO>();

    return (
        <Grid2 container size={12} mr={"5px"} ml={"5px"}>
            {(profile.addresses && profile.addresses.length === 0) && (
                <Typography
                    textAlign={"left"}
                    variant={"firstVariant"}
                >
                    Vous n'avez renseigné aucune adresse de livraison pour le moment.
                </Typography>
            )}

            {profile.addresses && profile.addresses.map((address: UserProfileAddressDTO, index: number) => {
                return (
                    <Grid2 key={address.id} container size={12} sx={{borderTop: '1px solid black'}} pt={"10px"}
                           pb={"10px"}>
                        <Grid2 container size={9}>
                            <Grid2
                                size={{xs: 12, sm: 4}}
                                sx={{
                                    alignContent: 'center',
                                }}
                            >
                                <Typography
                                    textAlign={"left"}
                                    variant={"firstVariant"}
                                    fontSize={{xs: '16px', sm: '18px'}}
                                >
                                    Adresse n°{index + 1}
                                </Typography>
                            </Grid2>
                            <Grid2 size={{xs: 12, sm: 8}} sx={{alignContent: 'center'}}>
                                <Typography
                                    textAlign={"left"}
                                    variant={"firstVariant"}
                                    fontSize={{xs: '14px', sm: '16px'}}
                                >
                                    {address.firstname} {address.lastname}
                                </Typography>
                                <Typography
                                    textAlign={"left"}
                                    variant={"firstVariant"}
                                    fontSize={{xs: '14px', sm: '16px'}}
                                >
                                    {address.street} {address.streetNumber}
                                </Typography>
                                <Typography
                                    textAlign={"left"}
                                    variant={"firstVariant"}
                                    fontSize={{xs: '14px', sm: '16px'}}
                                >
                                    {address.zip} {address.city}
                                </Typography>
                            </Grid2>
                        </Grid2>
                        <Grid2 size={3} sx={{
                            alignContent: 'center',
                            textAlign: 'left'
                        }}>
                            <IconButton
                                aria-label="Edit"
                                variant="thirdVariant"
                                onClick={(e) => {
                                    setSelectedAddress(address);
                                    setOpenAddAddress(true);
                                }}
                            >
                                <EditOutlined
                                    sx={{
                                        fontSize: {xs: '22px', sm: '25px'},
                                    }}
                                />

                            </IconButton>
                            <IconButton
                                aria-label="Delete"
                                variant="thirdVariant"
                                onClick={(e) => {
                                    setSelectedAddress(address);
                                    setOpenDeleteAddress(true);
                                }}
                            >
                                <DeleteOutline
                                    sx={{
                                        fontSize: {xs: '22px', sm: '25px'},
                                    }}
                                />

                            </IconButton>
                        </Grid2>
                    </Grid2>
                )
            })}

            <Grid2 size={12} mt={4} mb={4}>
                <Button
                    variant={"firstVariant"}
                    onClick={() => {
                        setSelectedAddress(undefined);
                        setOpenAddAddress(true)
                    }}
                >
                    Ajouter une adresse
                </Button>
            </Grid2>

            <ProfileAddressesAddModal open={openAddAddress} setOpen={setOpenAddAddress}/>

            {
                selectedAddress && (
                    <ProfileAddressesEditModal open={openAddAddress} setOpen={setOpenAddAddress}
                                               address={selectedAddress!}/>
                )
            }

            {
                selectedAddress && (
                    <ProfileAddressesDeleteModal open={openDeleteAddress} setOpen={setOpenDeleteAddress}
                                                 address={selectedAddress}/>
                )
            }

        </Grid2>
    );
}

export default ProfileAddressesDetails